export default "__VITE_ASSET__BEyiwCtb__"